module.exports = __webpack_public_path__ + "assets/locations/Shadow Cave/bg.jpg";